<script>
import { mapState, mapActions, mapGetters } from 'vuex'

import { Plugins } from '@capacitor/core'
const { Haptics } = Plugins

import ProductItem from './ProductItem'

const REMOVE_ITEM_TIMEOUT = 500
let timer = null

export default {
  name: 'ProductsList',
  components: { ProductItem },
  props: {
    products: { type: Array, required: true }
  },
  data: () => ({
    removeItem: false,
    scrolling: false
  }),
  computed: mapState({
    ...mapGetters('cart', ['cartConfig', 'cartSize']),
    cartItems: state => state.cart.items
  }),
  methods: {
    ...mapActions('cart', ['addProductToCart', 'removeProductFromCart']),

    // Will start timer on touchstart
    // After timeout reset product amount
    startRemoveTimer(product) {
      timer = setTimeout(() => {
        if (this.scrolling) return
        this.removeItem = true

        Haptics.vibrate()
        this.removeProductFromCart(product)
      }, REMOVE_ITEM_TIMEOUT)
    },

    // Reset timer
    stopTimer(product) {
      if (!this.removeItem && !this.scrolling) {
        if (this.cartSize >= this.cartConfig.maxCheckoutQuantity) {
          this.$toast.error(
            `Max ${this.cartConfig.maxCheckoutQuantity} portions per order`
          )
        }
        this.addProductToCart(product)
      }

      clearTimeout(timer)
      this.removeItem = false
      this.scrolling = false
    }
  }
}
</script>

<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap>
      <v-flex
        v-for="product in products"
        :key="product.id"
        xs6
        md4
        @mouseup.prevent="stopTimer(product)"
        @touchend.prevent="stopTimer(product)"
        @mousedown.prevent="startRemoveTimer(product)"
        @touchstart="startRemoveTimer(product)"
        @touchmove="scrolling = true"
      >
        <ProductItem
          :product="product"
          :quantity="
            (cartItems.find(x => x.id === product.id) || {}).quantity || 0
          "
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>
